/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface AdjointSearch
 */
export interface AdjointSearch {
    /**
     * 
     * @type {number}
     * @memberof AdjointSearch
     */
    idcentre?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdjointSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof AdjointSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof AdjointSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdjointSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof AdjointSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AdjointSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the AdjointSearch interface.
 */
export function instanceOfAdjointSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdjointSearchFromJSON(json: any): AdjointSearch {
    return AdjointSearchFromJSONTyped(json, false);
}

export function AdjointSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdjointSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcentre': !exists(json, 'idcentre') ? undefined : json['idcentre'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function AdjointSearchToJSON(value?: AdjointSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcentre': value.idcentre,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

